import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { generatePaymentMethodAdditionLinkQuery } from "@babackapp/private-api-client/client/use-generate-payment-method-addition-link-query";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
} from "@babackapp/ui/components/dialog";
import { WifiOff } from "lucide-react";
import { useCallback } from "react";

export default function BlockNotPaying() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const addPaymentMethod = useCallback(async () => {
    const { url } = await generatePaymentMethodAdditionLinkQuery({
      shopId: shop.id,
    });
    window.open(url, "_blank");
  }, [shop]);

  return (
    <Dialog open={true}>
      <DialogContent
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <div className="flex justify-between">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <WifiOff className="h-6 w-6 text-red-600" />
            </div>
            <div>
              {/* Remplacez par le composant AccountSwitcher2 si nécessaire */}
            </div>
          </div>
        </DialogHeader>
        <DialogDescription>
          <div className="space-y-2">
            <p className="">Bonjour,</p>
            <p>
              Malgré nos précédents rappels, au moins une facture reste impayée
              à ce jour. Conformément à nos conditions, nous sommes contraints
              de suspendre votre accès au service Baback jusqu'à régularisation
              de la situation.
            </p>
            <p>
              Pour rappel :<br />
              - BABACK SAS facture l'utilisation du logiciel.
              <br />- BABACK LOG SAS facture, le cas échéant, le transport
              retour.
            </p>
            <p>
              Nous vous invitons à procéder au règlement sans délai afin de
              rétablir votre accès. En cas d'erreur de notre part ou si le
              paiement a déjà été effectué, merci de nous contacter
              immédiatement.
            </p>
            <p>
              Nous comptons sur votre réactivité et vous remercions de votre
              compréhension.
            </p>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button onClick={() => addPaymentMethod()}>
            {t("settings.billing.updatePayementMethod")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
